import ApiService from "./ApiService";
import utilityService from "./utilityService";

const getAll = async () => {
  try {
    const url = "/GetAllCategorySecondaryOption";
    const response = await ApiService.get(url);
    if (response && response.data) return response.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return [];
};

const getOne = async (id) => {
  try {
    const url = `/GetCategorySecondaryOption?Id=${id}`;
    const response = await ApiService.get(url);
    if (response && response.data) return response.data;
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return null;
};

const update = async (data) => {
  const url =
    "/UpdateCategorySecondaryOption?" + utilityService.queryString(data);
  try {
    const result = await ApiService.post(url, data, {
      "Content-Type": "application/json",
    });
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return {
    success: false,
    message: "Failed to update category secondary option",
  };
};

const add = async (data) => {
  const url = "/AddCategorySecondaryOption?" + utilityService.queryString(data);

  try {
    const result = await ApiService.post(url, data, {
      "Content-Type": "application/json",
    });
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return {
    success: false,
    message: "Failed to add new category secondary option",
  };
};

const remove = async (id) => {
  const url = "/DeleteCategorySecondaryOption?Id=" + id;

  try {
    const result = await ApiService.post(url);
    if (result.status === 200)
      return {
        success: true,
        message: result.data,
      };
  } catch (err) {
    console.log("ApiError", err.message);
  }
  return {
    success: false,
    message: "Failed to remove category secondary option",
  };
};

export default {
  getAll,
  getOne,
  add,
  update,
  remove,
};
